
export default {
  props: {
    lang: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    language() {
      if (this.lang.includes('be')) return 'be';
      return this.lang;
    },
  },
};
